import { Subject } from 'rxjs';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as moment from 'moment';
import { FormGroup, FormBuilder, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from 'ngx-toastr';
import { HelperService } from 'src/app/common-service/helper.service';
import { interval } from 'rxjs';
import { InsadminService } from './../../inspection/services/insadmin/insadmin.service'
import { encryptionService } from './../../common-service/cedService'
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ServerURLService } from 'src/app/common-service/serverURL.service';

@Component({
  selector: 'app-accept-inspection-scehdule',
  templateUrl: './accept-inspection-scehdule.component.html',
  styleUrls: ['./accept-inspection-scehdule.component.css']
})


export class AcceptInspectionScehduleComponent implements OnInit {
  @ViewChild('nameInput', { static: false }) component
  reason: any;
  paramsId: any;
  paramsinspectorId: any;
  sheduleDetails: any;
  remarks: any
  InspectorDetails: any;
  today = moment().format('YYYY-MM-DD');
  status: boolean = false;
  remarksshowhide: boolean = false;
  pageshowhide: boolean = true
  accdenbuttonhide: boolean = true;
  errormsghide: boolean = true;
  comments: string;
  subscribe: Subject<any> = new Subject<any>();
  submitted = false;
  redirectPageCounter = 10;
  stateName = false;
  cityName = false;
  inspectionDate: any;
  inspectionDate2:any;
  inspectorStatus: any;
  roleName: string;
agreeCheckError: boolean = false;

  constructor(public route: ActivatedRoute, public tostar: ToastrService, public router: Router, private formBuilder: FormBuilder,
    public helper: HelperService, public insAdmin: InsadminService, private spinner: NgxSpinnerService, public ced: encryptionService, 
    private toastr: ToastrService, public serverURL: ServerURLService) { }
  formGroupId = this.formBuilder.group({
    name: ['', Validators.compose([Validators.required])],
    userEmail: ['', Validators.compose([Validators.required, Validators.pattern(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)])],
    addressLine1: ['', Validators.compose([Validators.required])],
    addressLine2: [''],
    countryId: ['', Validators.compose([Validators.required])],
    stateId: ['', Validators.compose([Validators.required])],
    cityId: ['', Validators.compose([Validators.required])],
    pinCode: ['', Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(6)])],
    mobileNumber: ['', Validators.compose([Validators.required, Validators.pattern('[6-9]\\d{9}')])],
    landlineNumber: [''],
    stateName: ['', Validators.compose([Validators.required])],
    cityName: ['', Validators.compose([Validators.required])],
    institutionTypeId: ['', Validators.compose([Validators.required])],
      agreeCheck: [false, Validators.requiredTrue]

  });
  get f() { return this.formGroupId.controls; }
  countryList: any = [];
  stateList: any = [];
  cityList: any = [];
  allstateList: any = [];
  allcityList: any = [];
  institutionTypeList: any = [];
  acceptenceType: any = [];
  insDate:any = [];

  ngOnInit(): void { 
    this.roleName=sessionStorage.getItem('selectedRole-usec');
  
    this.route.params.subscribe(params => {
      this.paramsId = +params.id;
      this.paramsinspectorId = +params.inspectorid
    });
    this.getSheduleDetails(); // Sheduling Details
    this.getInspectorDetails();
    this.acceptenceType = ['Retired', 'Not willing to conduct assessments anymore', 'Not available for inspection on assigned dates', 'Not willing to travel to states listed', 'Other reasons'];
  }

  getSheduleDetails() {
      // by gokul
      let idobjs = {
        'inspectionId': this.paramsId,
        'inspectorId': this.paramsinspectorId,
        'roleName':this.roleName

      }
      this.spinner.show();
      this.insAdmin.getSheduleDetails(idobjs)
        .pipe(takeUntil(this.subscribe))
        .subscribe((data: any) => {
          data.startDate = moment(data.startDate).format('DD-MM-YYYY');
          data.endDate = moment(data.endDate).format('DD-MM-YYYY');

        this.inspectionDate = moment(data.inspectionDate).format('DD-MM-YYYY');
       if(data.noOfInspDays!=null && data.noOfInspDays!=""){
        if(data.noOfInspDays==2){
           let dateObject = moment(data.inspectionDate).add(1, 'days').format('DD-MM-YYYY');
           this.inspectionDate =this.inspectionDate+ " & "+ dateObject;
        }
       }
        
      
          this.sheduleDetails = data;
          for (let i = 0; i < this.sheduleDetails.inspectionAppointedInspectors.length; i++) {
            if (this.sheduleDetails?.inspectionAppointedInspectors[i]?.inspector?.inspectorId === this.paramsinspectorId && this.sheduleDetails?.inspectionAppointedInspectors[i]?.inspectionScheduleMasterId === this.paramsId) {
              this.inspectorStatus = this.sheduleDetails?.inspectionAppointedInspectors[i]?.inspectorStatus?.name;
              // if (this.inspectorStatus == "Accepted" || this.inspectorStatus == "Denied" 
              // || this.inspectorStatus == "Cancelled" || this.inspectorStatus == "Not Responded") {
              //  this.pageshowhide = false;
              // } else {
              //  this.pageshowhide = true;
              // }
            }

          }
          this.spinner.hide();
        }, error => {
          console.log(error);
          this.spinner.hide();
        });
  }
  getInspectorDetails() {
    this.route.params.subscribe(params => {
      this.paramsId = +params.id;

      this.paramsinspectorId = +params.inspectorid
      let idobj = {
        'inspectionId': this.paramsId,
        'inspectorId': this.paramsinspectorId
      }
      this.insAdmin.getInspectorDetails(idobj)
        .pipe(takeUntil(this.subscribe))
        .subscribe((data: any) => {
          this.InspectorDetails = data;
        }, error => {
          console.log(error);
        });
    });
  }

  public acceptenceTypes(event: any) {
    this.remarks = event;
    if (event == "Retired" || event == "Not willing to conduct assessments anymore" || event == "Not available for inspection on assigned dates") {
      this.remarksshowhide = false;
    } else {
      this.remarksshowhide = true;
    }

  }

  acceptenceTypesothers(event: any) {
    this.remarks = event;
  }

  onSubmit(Status) {
    // setTimeout(() => {
    // }, 5000);

    if (Status == 'Accept') {
    if (!this.formGroupId.get('agreeCheck')?.value) {
      this.agreeCheckError = true;  
      this.displayErrorMsg('error', 'Please check the declaration checkbox before Accept.');
      return;  // STOP submit
    } else {
      this.agreeCheckError = false;
    }
  }
    if (Status == 'Accept') {
      this.status = true
      this.remarks='-';
    } else {
      this.status = false
      if (this.remarks == null || this.remarks == "" || this.remarks == undefined) {
  this.errormsghide= false;
  //this.accdenbuttonhide = true;
        this.displayErrorMsg('error', 'Reason is required');
        return;
      }else{
        this.errormsghide= true;
       if( this.remarks == "Not willing to conduct assessments anymore" || this.remarks  == "Retired"){
        this.deleteIns();
       }
      }
      // this.remarks='Not accepted';
    }
    // this.submitted = true;
    // ;
    // // stop here if form is invalid
    // if (this.formGroupId.invalid) {
    //   return;
    // }



    let InspectionObj = '';
    this.submitRegistration(InspectionObj)
    // let ecUserSignUp = { 'applicantName': ecApplicantSignUpObj['name'], 'emailId': ecApplicantSignUpObj['userEmail'] }
    // this.insAdmin.applicantSignUp(ecUserSignUp).subscribe((data: any) => {
    //   if (data.response.respcode == '2000') {
    //     this.ced.encryptingProcess('access-token', data.access_token);
    //     this.ced.encryptingProcess('refresh-token', data.refresh_token);
    //     ecApplicantSignUpObj['oAuthUserId'] = data.oAuthUserId
    //     this.submitRegistration(ecApplicantSignUpObj)
    //   } else if (data.response.respcode == '500') {
    //     this.spinner.hide();
    //     this.displayErrorMsg('error', data.response.message);
    //     this.clearSession();
    //   } else {
    //     this.spinner.hide();
    //     this.displayErrorMsg('error', 'Applicant Signup is Failed!!');
    //     this.clearSession();
    //   }
    // }, error => {
    //   this.spinner.hide();
    //   console.log(error);
    //   error.status = error.status == 0 ? 500 : error.status
    //   this.clearSession();
    // });


  }
 // delete Inspector
   // delete Inspector
   deleteIns() {    
    const obj = {
      inspectorId: this.ced.encryptAesToString(this.paramsinspectorId, this.serverURL.secretKey).toString(),
      status: "InActive"
    }
    this.insAdmin.deletedIsnpector(obj)
      .pipe(takeUntil(this.subscribe))
      .subscribe((deleted: any) => {
  
      }, error => {
        console.log(error);
      });
  }
  private submitRegistration(ecApplicantRegObj: any) {   
    this.spinner.show();
    this.insAdmin.acceptinspectionscehdule(this.paramsId, this.paramsinspectorId, this.status, this.remarks)
      .pipe(takeUntil(this.subscribe))
      .subscribe((data: any) => {
        // this.clearSession();
        this.spinner.hide();
        if (this.status == true) {
          this.tostar.success('Please Check Your Email Confirmation Email Sent Successfully', 'Success', {
            timeOut: 3000
          });
        } else if(this.errormsghide== true){
          this.displayErrorMsg('success', 'Thank You!!! Denied Successfully!')
        }
        // this.accdenbuttonhide = false;
        // if (data.response.respcode == '200') {
        //   this.tostar.success('Registered successfully', 'Success', {
        //     timeOut: 2000
        //   });
        //   this.startCounterToRedirect();
        // } else if (data.response.respcode == '500') {
        //   this.displayErrorMsg('error', data.response.message);
        // } else {
        //   this.displayErrorMsg('error', 'Applicant Registration is Failed!!');
        // }
        let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);
      }, error => {
        this.spinner.hide();
        error.status = error.status == 0 ? 500 : error.status
        this.helper.errorMessage(error);
        this.clearSession();
      });

  }
  fieldTextType: boolean;
  confirmfieldTextType: boolean;
  private startCounterToRedirect() {
    const numbers = interval(1000);
    const redirectSubscriber = numbers.subscribe(x => {
      this.redirectPageCounter--;
      if (this.redirectPageCounter == 0) {
        redirectSubscriber.unsubscribe();
        this.redirectTo();
      }
    });
  }
  public redirectTo() {
    this.router.navigate(['/login']);
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  private displayErrorMsg(type: string, msg: string) {
    if (type == 'error') {
      this.toastr.error(msg, 'Error', {
        timeOut: 3000
      });
    }
    else if (type === 'success') {
      this.toastr.success(msg, '', {
        timeOut: 3000
      });
    }
  }
  private clearSession() {
    sessionStorage.clear();
    localStorage.clear();
  }

  toggleConfirmFieldTextType() {
    this.confirmfieldTextType = !this.confirmfieldTextType;
  }

  keyPresspincode(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }


  // Only AlphaNumeric with Some Characters [-_ ]
  keyPressAlphaNumericWithCharacters(event) {

    var inp = String.fromCharCode(event.keyCode);
    // Allow numbers, alpahbets, space, underscore
    if (/[a-zA-Z-_ ]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }
}


